import { LOCALES } from '@marketplace/i18n';

export const activateDeactivateCompletionI18n = {
  [LOCALES.ENG]: {
    deactivated_completion_message: "This application is deactivated and no longer available for end-users.",
    activated_completion_message: 'This application is activated and available for end-users again.'
  },
};